var map = {
	"./OTP.png": "53e5",
	"./atf.png": "2523",
	"./base.png": "3520",
	"./cit.png": "4271",
	"./default.png": "b13e",
	"./dm.png": "e255",
	"./efiling.png": "bdb5",
	"./evr.png": "6c1f",
	"./home.png": "479a",
	"./ntpf.png": "071c",
	"./rnd.png": "2148",
	"./tax_plus.png": "82db",
	"./tda.png": "7c85",
	"./tom.png": "e423",
	"./tra.png": "c7e8",
	"./vat.png": "a973",
	"./vat_report.png": "e5d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b60d";